class SearchModal extends HTMLElement {
  constructor() {
    super()
    this.modalToggle = document.querySelectorAll("[aria-controls='search-modal']")
    this.detailsContainer = this.querySelector("div.header__search")
    this.modalOverlay = this.querySelector("div.header__search__overlay")
    this.modalToggle.forEach((btn) => {
      btn.addEventListener("click", this.onToggleClick.bind(this))
    })

    this.querySelector('button[type="button"]').addEventListener("click", this.closeModal.bind(this))
  }

  initialize() {}

  onToggleClick(event) {
    event.preventDefault()

    this.detailsContainer.hasAttribute("open") ? this.closeModal() : this.openModal(event)
  }

  openModal(event) {
    this.detailsContainer.setAttribute("open", "true")
    this.modalOverlay.addEventListener("click", this.overlayClick.bind(this))
    document.body.classList.add("overflow-hidden")

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    )
  }

  closeModal(focusToggle = true) {
    // removeTrapFocus(focusToggle ? this.modalToggle : null)
    this.detailsContainer.removeAttribute("open")
    this.detailsContainer.querySelector('input:not([type="hidden"])').value = ""
    this.modalOverlay.removeEventListener("click", () => {})
    document.body.classList.remove("overflow-hidden")
  }

  overlayClick() {
    this.closeModal()
  }
}

customElements.define("search-modal", SearchModal)

class PredictiveSearch extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector("#predictive-search")

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event)
      }, 300).bind(this),
    )
  }

  onChange() {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.close()
      return
    }

    this.getSearchResults(searchTerm)
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=20&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        this.predictiveSearchResults.innerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML
        this.open()
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  open() {
    this.predictiveSearchResults.style.display = "block"
  }

  close() {
    this.predictiveSearchResults.style.display = "none"
  }

  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}

customElements.define("predictive-search", PredictiveSearch)
